import { AuditIntegrityPanel } from '../../components/AuditIntegrityPanel';
import { IpAllowlistPanel } from '../../components/IpAllowlistPanel';

/** Security section: control-plane IP allowlist and tamper-evident audit verification. */
export function SecuritySettings(): JSX.Element {
  return (
    <>
      <IpAllowlistPanel />
      <AuditIntegrityPanel />
    </>
  );
}
